import { render, staticRenderFns } from "./ProfileHistoryItem.vue?vue&type=template&id=6a220121&"
import script from "./ProfileHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ProfileHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports